/**
 * Thin wrapper around the gtag.js tag loaded in index.html (Google Ads,
 * AW-17628969255). Safe to call when the tag is blocked or absent.
 *
 * Funnel events currently fired:
 *  - partner_modal_open  — a "Partner with us" CTA opened the form
 *  - generate_lead       — the form was submitted successfully
 *
 * To count a Google Ads conversion, add the conversion label from the Ads
 * account: gtag('event', 'conversion', { send_to: 'AW-17628969255/<label>' })
 * inside trackLead(). Meta Pixel / Hotjar are not installed (see CLAUDE.md).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (name: string, params?: Record<string, unknown>): void => {
  try {
    window.gtag?.('event', name, params);
  } catch {
    // analytics must never break the app
  }
};

export const trackPartnerModalOpen = (): void => trackEvent('partner_modal_open');

export const trackLead = (language: string): void => {
  trackEvent('generate_lead', { language });
};
